AddPageSwapTrigger(function(){
    function activateBackDrop() {
        $('#wrapper').addClass("dropdownmainhover");
        $('footer.megafooter').addClass("dropdownmainhover");
    }

    function deactivateBackDrop() {
        $('#wrapper').removeClass("dropdownmainhover");
        $('footer.megafooter').removeClass("dropdownmainhover");
    }

    function bindOnElementMouseOver($el) {
        $el.unbind('mouseover');
        $el.unbind('mouseleave');

        $el.mouseleave(deactivateBackDrop);
        $el.mouseover(activateBackDrop);
    }

    function bindOnElementClick($el) {
        $el.unbind('click');
        $el.unbind('mouseleave');

        $el.mouseleave(deactivateBackDrop);
        $el.click(activateBackDrop);
    }

    bindOnElementMouseOver($("#dropdownmain"));
    bindOnElementMouseOver($("#dropdownmegamenu"));
    bindOnElementMouseOver($("#dropdownmegamenu2"));
    bindOnElementMouseOver($("#dropdownzorg"));

    bindOnElementClick($(".sk-col-search2"));

});